const navigation = [
  // Example placeholders if you want social icons:
  // {
  //   name: 'GitHub',
  //   href: 'https://github.com/',
  //   icon: (props) => (
  //     <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
  //       {/* ... */}
  //     </svg>
  //   ),
  // },
];

export default function Footer() {
  return (
    <footer className="bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 py-12 text-white">
        <div className="text-center">
          <p className="text-xs leading-5 text-gray-400">
            <span className="text-atticusOrange-600">&copy;</span>{' '}
            {new Date().getFullYear()} Atticus Labs LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
